import TopBar from "../components/TopBar";
import BottomBar from "../components/BotomBar";
import { Outlet } from "react-router";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMe } from "../redux/slices/userSlice";
import NotificationSnackBar from "../components/NotificationSnackBar";
import { resetNotification } from "../redux/slices/notificationsSlice";
import { useMediaQuery } from "react-responsive";
import { Button, CircularProgress, Stack, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { useTranslation } from "react-i18next";
import { logOut } from "../redux/slices/authenticationSlice";
import { useAuth } from "../hooks/useAuth";

const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
    maxWidth: "700px",
    margin: "auto",
  },
};

function Home() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { logout } = useAuth();
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const [isLoading, setIsLoading] = useState(false);
  const [isLastDayAlertShowing, setIsLastDayAlertShowing] = useState(false);
  const [doNotShowAlert, setDoNotShowAlert] = useState(false);

  const isBottomBarVisible = useSelector(
    (state) => state.common.isBottomBarVisible
  );
  const notificationsState = useSelector((state) => state.notifications);
  const getCurrentUserRoleLoading = useSelector(
    (state) => state.authentication.getCurrentUserRoleLoading
  );
  const userLogInLoading = useSelector(
    (state) => state.authentication.userLogInLoading
  );
  const onCloseLastDayAlertDialog = () => {
    setIsLastDayAlertShowing(false);
  };
  const onHideLastDayAlert = () => {
    setDoNotShowAlert(true);
    localStorage.setItem("isLastDayAlertHidden", true);
  };
  useEffect(() => {
    setIsLoading(
      userLogInLoading === "PENDING" || getCurrentUserRoleLoading === "PENDING"
    );
  }, [userLogInLoading, getCurrentUserRoleLoading]);
  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);
  useEffect(() => {
    const isAlertHidden = localStorage.getItem("isLastDayAlertHidden");
    if (!isAlertHidden) {
      setIsLastDayAlertShowing(true);
    }
  }, []);

  const handleOnCloseNotificationSnackBar = () => {
    dispatch(resetNotification());
  };
  const onLogout = () => {
    dispatch(logOut()).then(() => {
      logout();
    });
  };
  return (
    <div style={styles.root}>
      {isLoading ? (
        <Stack
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
        >
          <CircularProgress color="error" />
        </Stack>
      ) : (
        <>
          {isTabletOrMobile ? (
            <>
              <TopBar />
              <Box paddingTop={6} paddingBottom={6}>
                <Outlet />
              </Box>
              {isBottomBarVisible && <BottomBar />}
              <NotificationSnackBar
                open={notificationsState.show}
                onClose={handleOnCloseNotificationSnackBar}
                message={notificationsState.message}
                duration={notificationsState.duration}
                severity={notificationsState.severity}
              />
            </>
          ) : (
            <Stack
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
              textAlign="center"
            >
              <WarningAmberIcon sx={{ fontSize: 80 }} color="error" />
              <Typography color="error" variant="h3">
                {t("onlyOnMobViewing")}
              </Typography>
              <Button onClick={onLogout}>{t("login.logOut")}</Button>
            </Stack>
          )}
        </>
      )}
      {/* {isLastDayAlertShowing && (
        <Dialog
          open={isLastDayAlertShowing}
          onClose={onCloseLastDayAlertDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description1"
        >
          <DialogTitle textAlign="center" id="alert-dialog-title">
            {t("lastDayAlert.title")}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description3">
              <Typography color="black" variant="subtitle-1">
                {t("lastDayAlert.content")}
              </Typography>
            </DialogContentText>
            <Stack display="flex" direction="row" alignItems="center" sx={{ marginLeft: "-12px" }}>
              <Checkbox
                checked={doNotShowAlert}
                onChange={onHideLastDayAlert}
              />
              <Typography component="div">
                {t("lastDayAlert.doNotShowAlert")}
              </Typography>
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button onClick={onCloseLastDayAlertDialog}>
              {t("alertDialog.confirm")}
            </Button>
          </DialogActions>
        </Dialog>
      )} */}
    </div>
  );
}

export default Home;
